import type { CSSProperties, ReactNode } from "react";

interface TableCellProps {
    children: ReactNode;
    highlighted?: boolean;
    align?: "left" | "center" | "right";
    width?: string;
    style?: CSSProperties;
}

const TableCell = ({ children, highlighted, align = "left", width, style }: TableCellProps) => {
    return (
        <td
            style={{
                padding: "12px 8px",
                borderBottom: "1px solid #eaeaea",
                backgroundColor: highlighted ? "#FFF9E6" : "transparent",
                textAlign: align,
                fontSize: "12px",
                color: "#2D2D2D",
                width: width,
                verticalAlign: "middle",
                ...style,
            }}
        >
            {children}
        </td>
    );
};

export default TableCell;
